import React from 'react'
import PropTypes from 'prop-types'
import { StackView, Icon } from '@telus-uds/components-web'
import styled from 'styled-components'

const IconWrapper = styled.span`
  margin-right: 8px;
`
IconWrapper.displayName = 'IconWrapper'

const WithIcon = ({ children, icon }) => {
  // Check if icon is a valid component before rendering
  if (!icon) {
    // If icon is not provided, just return the children without the icon wrapper
    return children
  }

  return (
    <StackView testID="with-icon" direction="row" tokens={{ alignItems: 'center' }}>
      <IconWrapper>
        <Icon icon={icon} variant={{ size: 'micro' }} />
      </IconWrapper>
      {children}
    </StackView>
  )
}
WithIcon.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired
}

export default WithIcon
